// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.file-upload-wrapper[data-v-bd143ac2]{\n  display: flex;\n  justify-content: center;\n}\n.file-input[data-v-bd143ac2] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n.image-remove-btn[data-v-bd143ac2]{\n  position: absolute;\n    right: 0;\n    margin: 10px 24px;\n    z-index: 999;\n}\n.image-list-item[data-v-bd143ac2]{\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
